"use client";

import CountryFlag from "./CountryFlag";

export interface VideoCardProps {
  title: string;
  videoCode: string;
  filterType?: string;
}

export default function VideoCard({
  title,
  videoCode,
  filterType,
}: VideoCardProps) {
  return (
    <div className="video-card-modern h-100">
      <div className="video-card-iframe-wrap">
        <iframe
          src={videoCode}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <div className="video-card-body">
        {filterType && (
          <span className="video-card-tag">
            <CountryFlag country={filterType} fallback={null} />
            <i className="fa-solid fa-tag"></i> {filterType}
          </span>
        )}
        <h4 className="video-card-title">{title}</h4>
      </div>
    </div>
  );
}
